import React from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import App from "./App";
import { WorkoutProvider } from "./contexts/WorkoutContext";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProfileProvider } from "./contexts/UserProfileContext";
import { SocialProvider } from "./contexts/SocialContext";
import { ToastProvider } from "./contexts/ToastContext";
import { ConnectedEquipmentProvider } from "./contexts/ConnectedEquipmentContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getGoogleClientId } from "./services/googleOAuth";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";
import { captureIncomingLink } from "./utils/shareLinks";
import { captureNexusLink } from "./utils/nexusLink";

const clientId = getGoogleClientId();

// Runs before the first render, and therefore before AuthContext's
// history.replaceState wipes the query string on an OAuth return. A share or
// invite code arriving in the URL is moved into storage here, where it can
// survive a full Google sign-in round-trip; IncomingLinkDialog picks it up.
captureIncomingLink();
// Same reason for a Nexus link request (/link/nexus?code=…); NexusLinkDialog handles it.
captureNexusLink();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <ToastProvider>
        <AuthProvider>
          <UserProfileProvider>
            <SocialProvider>
              <WorkoutProvider>
                <ConnectedEquipmentProvider>
                  <App />
                </ConnectedEquipmentProvider>
              </WorkoutProvider>
            </SocialProvider>
          </UserProfileProvider>
        </AuthProvider>
      </ToastProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

// Precaches the app shell and watches for new builds. The prompt to take an
// update is raised from App (useServiceWorkerUpdate), which can see whether a
// session is running; registration itself has to happen out here.
registerServiceWorker();
